import React from 'react'
import { useProgressiveImg } from 'hooks'
import { makeStyles } from '@material-ui/core/styles'

/**
 *
 */
export const imagePlaceholder = 'data:image/octet-stream;base64,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'

const usePictureStyles = makeStyles(theme => ({
    picture: {
        position: 'relative',
        '&::before': {
            content: ({ imgLoading }: { imgLoading: boolean }) => imgLoading ? '""' : 'none',
            position: 'absolute',
            inset: 0,
            animation: '$pulse 2s infinite',
            zIndex: 1
        },
        '& img': {
            objectFit: 'cover',
            filter: ({ imgLoading }: { imgLoading: boolean }) => imgLoading ? 'blur(1px)' : 'none'
        }
    },
    '@keyframes pulse': {
        '0%': {
            backgroundColor: 'rgba(255, 255, 255, 0)'
        },
        '50%': {
            backgroundColor: 'rgba(56, 55, 55, 0.2)'
        },
        '100%': {
            backgroundColor: 'rgba(255, 255, 255, 0)'
        }
    }
}))
/**
 *
 */
const Picture = ({ sources, thumbnail, alt, attributes }: { sources: React.SourceHTMLAttributes<HTMLSourceElement>[], thumbnail?: string, alt?: string, attributes?: React.ImgHTMLAttributes<HTMLImageElement> }): JSX.Element => {
    const imgSrc = sources.filter(source => window.matchMedia(source.media).matches)[0]?.src || sources[0].src
    const [src, { imgLoading }] = useProgressiveImg(thumbnail || imagePlaceholder, imgSrc)
    const classes = usePictureStyles({ imgLoading })

    return (
        <picture {...attributes} className={`${classes.picture} ${attributes?.className}`}>
            {sources.map((source, index) => <source key={index} {...source} srcSet={imgLoading ? src : source.src}></source>)}
            <img src={thumbnail || imagePlaceholder} alt={alt || 'image'} />
        </picture>
    )
}

export default Picture
